import Vue from 'vue'

let store = {
  state: Vue.observable({
    drawInfo: {},
    userInfo: {},
    winPoster: '',
    prize_title: '',
    pageName: ''
  }),
  setState (key, val) {
    this.state[key] = val
  }
}

export default store
